import React, {FC, useEffect} from 'react';

import {Loader} from '@gravity-ui/uikit';
import usePrepareData from 'ui/hooks/usePrepareData';
import i18n from 'ui/i18n';
import {actions, selectors, useAppDispatch, useAppSelector} from 'ui/store';
import * as Metrika from 'ui/utils/metrika';

import CollapsableCard from '../CollapsableCard';
import QuestionInfo from '../QuestionInfo';
import QuestionResults from '../QuestionResults';

import {ResultsProps} from './Results.types';

const {selectResults} = selectors;
const {prepareResults} = actions;

const Results: FC<ResultsProps> = ({answerKey}) => {
    const dispatch = useAppDispatch();
    const isPreparedData = usePrepareData([prepareResults({answerKey})], dispatch);

    const resultsData = useAppSelector(selectResults);

    useEffect(() => {
        Metrika.results();
    }, []);

    if (isPreparedData && resultsData.data.length === 0) {
        return null;
    }
    return (
        <CollapsableCard
            title={i18n('success-page', 'results-title')}
            openedByDefault={false}
            uniqKey="results"
        >
            {isPreparedData ? (
                <>
                    {resultsData.data.map((result) => (
                        <QuestionInfo
                            key={result.id}
                            label={result.label}
                            info={i18n('success-page', 'results-score', {
                                count: Number(result.scores),
                            })}
                        >
                            <QuestionResults
                                type={result.type}
                                value={result.value}
                                items={result.items}
                                widget={result.widget}
                            />
                        </QuestionInfo>
                    ))}
                </>
            ) : (
                <Loader size="m" />
            )}
        </CollapsableCard>
    );
};
export default Results;
